import { Modal, message } from 'antd';
import fetch from '../fetch';


const generate = (orgId) => {
    return fetch.post(`jxcpReport/generate/${orgId}`, {})
}


export default {
    generate,
}